import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { Observable ,  Subscription } from 'rxjs';
import { ProductViewHelperService } from '../../../shared-postlogin/services/product-view-helper.service';
import { AudioPlayerService }  from './../../services/audio-player.service';
import { AuthService } from '../../../app/services/auth.service';


@Component({
    selector: 'submitted-speaking-pSkill',
    templateUrl: './submitted-speaking-pSkill.template.html',
    styleUrls: ['./submitted-speaking-pSkill.style.scss'],
    standalone: false
})
export class SubmittedSpeakingPSkill implements OnInit, OnDestroy {
  private resetSubscription: any;
  private stopAllOtherAudiosOnPlayingOneAudioSubscription: any;
  private audioElement: HTMLAudioElement;
  /** Event handler for `loadedmetadata` event on the audio element */
  private readonly metadataLoadedListener = () => {
    this.audioDuration = this.calculateRecordingTimer(
      this.audioElement.duration
    );
  };
  /** Event handler for `timeupdate` event on the audio element */
  private readonly timeUpdateListener = () => {
    //Audio Seeker update while playing audio
    this.audioSeeker = this.calculateRecordingTimer(this.audioElement.currentTime);
    if (this.audioElement.currentTime === this.audioElement.duration) {
      this.playerState = 'stopped';
    }
  };

  @Input() audioSrc: string;
  @Input() resetSubmittedSpeakingPSkillSubject: Observable<void>;
  playerState: string;//After submission player state tracker
  audioSeeker: string;
  audioDuration: string;
  segment: string;
  @Input() attemptNumber : number;
  stopOtherAudioActivitiesSubscription : Subscription;

  constructor(
    private productViewHelperService : ProductViewHelperService,
    private audioPlayerService : AudioPlayerService,
    private authService : AuthService,
    ){}

  ngOnInit(){
    // NEMO-11467, NEMO-11684: Hardcoding play button color for "adult" segment.
    const userRole = this.authService.getUserData() ? this.authService.getUserData().role : "";
    this.segment = userRole === 'student' && this.productViewHelperService.getSegment() ? this.productViewHelperService.getSegment() : "adult";
    this.resetSubscription = this.resetSubmittedSpeakingPSkillSubject.subscribe(() => this.resetSpeakingProductiveSkill())
    this.resetSpeakingProductiveSkill();

    // Audio player implementation using HTMLAudioElement.
    this.audioElement = new Audio(this.audioSrc);
    this.audioElement.addEventListener("loadedmetadata", this.metadataLoadedListener);
    this.audioElement.addEventListener("timeupdate", this.timeUpdateListener);

    this.stopAllOtherAudiosOnPlayingOneAudioSubscription = this.productViewHelperService.stopAllOtherAudiosOnPlayingOneAudio.subscribe((attemptNumber)=> {
      //On Playing one audio stop all other audios 
      if(this.attemptNumber != attemptNumber) {
        this.stopPlayingAudio();
      }
    })
    this.stopOtherAudioActivitiesSubscription = this.audioPlayerService.audioPromptPlayEvent.subscribe( () => {
      if (this.playerState === "playing") {
          this.stopPlayingAudio();
      }
    })
  }

  //Play the audio
  async playAudio() {
    this.audioPlayerService.pauseAudioPromptPlayer();
    this.productViewHelperService.stopAllOtherAudiosOnPlayingOneAudio.next(this.attemptNumber);

    const updatedSignedURL = await this.productViewHelperService.checkExpiryAndReturnUpdatedSignedURL(this.audioElement.src, 
      {
        audioDuration: this.audioElement.duration,
        timestampQueryParamRequired: false
      });
    if (updatedSignedURL) {
      this.audioElement.src = updatedSignedURL;
    }

    this.playerState = "playing";
    this.audioElement.play();
  }

  //Stop the audio
  stopPlayingAudio() {
    this.playerState = "stopped";
    this.audioElement.pause();
    this.audioElement.currentTime = 0;
  }

  private resetSpeakingProductiveSkill() {
    this.playerState = "stopped";
    this.audioSeeker = '';
    // this.audioDuration = '';
    setTimeout(() => {
      if (this.audioElement) {
        this.stopPlayingAudio();
      }
    }, 0);
  }

  public calculateRecordingTimer(t) {
    var sec_num = parseInt(t, 10); // don't forget the second param
    var hours: any = Math.floor(sec_num / 3600);
    var minutes: any = Math.floor((sec_num - (hours * 3600)) / 60);
    var seconds: any = sec_num - (hours * 3600) - (minutes * 60);

    if (hours < 10) { hours = "0" + hours; }
    if (minutes < 10) { minutes = "0" + minutes; }
    if (seconds < 10) { seconds = "0" + seconds; }
    return hours + ':' + minutes + ':' + seconds;
  }

  ngOnDestroy() {
    this.resetSubscription.unsubscribe();
    if(this.stopAllOtherAudiosOnPlayingOneAudioSubscription) {
      this.stopAllOtherAudiosOnPlayingOneAudioSubscription.unsubscribe();
    }
    if(this.stopOtherAudioActivitiesSubscription) {
      this.stopOtherAudioActivitiesSubscription.unsubscribe();
    }

    // Destroy the Audio element
    if (this.audioElement) {
      this.audioElement.pause();
      this.audioElement.removeEventListener('loadedmetadata', this.metadataLoadedListener);
      this.audioElement.removeEventListener('timeupdate', this.timeUpdateListener);      
      this.audioElement.src = '';
      this.audioElement = null;
    }
  }

}

